import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import BulkActionDropdown from './BulkActionDropdown';

class BulkActionButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { active: false };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.setState(state => ({ active: !state.active }));
  }

  render() {
    const { active } = this.state;
    const buttonStyles = classNames(
      'NewButton NewButton--center NewButton--small IndexFilter-actionButton',
      {
        'IndexFilter-actionButton--active': active,
      },
    );
    const textStyles = classNames('ml-8', {
      'c-brand-gray-darkest': !active,
      'c-white': active,
    });

    return (
      <div className="BulkAction-button pos-r ml-a">
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div className={buttonStyles} onClick={this.toggleMenu}>
          <Icon name="list-ul" />
          <span className={textStyles}>{I18n.t('actions.bulk')}</span>
        </div>
        {active && (
          <BulkActionDropdown {...this.props} toggleMenu={this.toggleMenu} />
        )}
      </div>
    );
  }
}

export default BulkActionButton;
